import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { SectionWrapper } from '../components/ui/SectionWrapper';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { ArrowRight, Clock, ArrowLeft } from 'lucide-react';
import { guides, categories } from '../data/guides';
export function CategoryPage() {
  const {
    slug
  } = useParams();
  const category = categories.find(c => c.id === slug);
  const categoryGuides = guides.filter(g => g.category === slug);
  if (!category) {
    return <SectionWrapper data-id="element-328">
        <div className="text-center py-20" data-id="element-329">
          <h1 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-330">
            Category not found
          </h1>
          <Link to="/guides" data-id="element-331">
            <Button variant="primary" data-id="element-332">Browse All Categories</Button>
          </Link>
        </div>
      </SectionWrapper>;
  }
  const Icon = category.icon;
  return <div className="bg-slate-50 min-h-screen pb-20" data-id="element-333">
      <div className="bg-white border-b border-slate-200 py-16 px-6" data-id="element-334">
        <div className="max-w-6xl mx-auto" data-id="element-335">
          <Link to="/guides" className="inline-flex items-center text-sm text-slate-500 hover:text-teal-700 mb-6 transition-colors" data-id="element-336">
            <ArrowLeft className="w-4 h-4 mr-1" data-id="element-337" /> All Categories
          </Link>

          <div className="flex items-center gap-4 mb-4" data-id="element-338">
            <div className="p-3 bg-teal-50 rounded-lg text-teal-700" data-id="element-339">
              <Icon size={32} data-id="element-340" />
            </div>
            <h1 className="text-4xl font-bold text-slate-900" data-id="element-341">
              {category.label}
            </h1>
          </div>

          <p className="text-lg text-slate-600 max-w-2xl" data-id="element-342">
            Independent evaluations and guides related to{' '}
            {category.label.toLowerCase()} in the door-to-door industry.
          </p>
        </div>
      </div>

      <SectionWrapper background="muted" data-id="element-343">
        {categoryGuides.length > 0 ? <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-344">
            {categoryGuides.map(guide => <Link key={guide.id} to={`/guide/${guide.id}`} className="block h-full" data-id="element-345">
                <Card hover className="flex flex-col h-full border-slate-200" data-id="element-346">
                  <h3 className="text-lg font-bold text-slate-900 mb-3 leading-snug" data-id="element-347">
                    {guide.title}
                  </h3>
                  <p className="text-slate-600 text-sm leading-relaxed mb-6 flex-grow" data-id="element-348">
                    {guide.description}
                  </p>
                  <div className="flex items-center justify-between pt-4 border-t border-slate-100 mt-auto" data-id="element-349">
                    <span className="flex items-center text-xs text-slate-400 font-medium" data-id="element-350">
                      <Clock className="w-3 h-3 mr-1" data-id="element-351" /> {guide.readTime}
                    </span>
                    <span className="text-sm font-medium text-teal-700 flex items-center group" data-id="element-352">
                      Read Guide{' '}
                      <ArrowRight className="ml-1 w-3 h-3 group-hover:translate-x-1 transition-transform" data-id="element-353" />
                    </span>
                  </div>
                </Card>
              </Link>)}
          </div> : <div className="text-center py-12 bg-white rounded-lg border border-slate-200 border-dashed" data-id="element-354">
            <p className="text-slate-500 mb-4" data-id="element-355">
              No guides published in this category yet.
            </p>
            <Link to="/guides" data-id="element-356">
              <Button variant="outline" data-id="element-357">Browse Other Guides</Button>
            </Link>
          </div>}
      </SectionWrapper>
    </div>;
}